<template>
  <v-app v-if="isLoading">
    <loading />
  </v-app>
  <div v-else>
    <v-col cols="12" class="pa-3">
      <v-row>
        <v-col cols="12" md="9" class="pt-2">
          <v-card
            class="EK-card rounded-xl border-top border-right rounded-tr-0 EK-shadow IMTOrange"
          >
            <v-data-table
              dense
              :headers="headers"
              :items="smsList"
              hide-default-footer
              :search="searchText"
              :items-per-page="10"
              :page.sync="page"
              @page-count="pageCount = $event"
            >
              <template v-slot:top>
                <v-text-field
                  v-model="searchText"
                  color="IMThemeGray"
                  style="width: 280px"
                  label="بحث في الجدول"
                  append-icon="mdi-magnify"
                  class="mx-4"
                ></v-text-field>
              </template>
              <template v-slot:item="{ item, index }">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                      <tr 
                        v-on="on" v-bind="attrs"
                        >
                        <td>
                            {{ item.id }}
                          </td>
                          <td>
                            {{ item.message   }}
                          </td>  
                        
                        <td>
                            {{ item.shopName    }}
                          </td>
                          <td>
                            {{   item.clientFullName }}
                          </td>
                          <td>
                            {{   item.phoneNumber }}
                          </td>
                          <td>
                            {{   item.userFullName }}
                          </td>
                          
                          <td>
                                {{ 
                                    new Date(item.sendDate).toLocaleTimeString("ar-GB") 
                                    + " " + 
                                    new Date(item.sendDate).toISOString().substr(0, 10)
                                }}
                            </td>
                        </tr>
                    </template>
                    <span>-</span>
                </v-tooltip>
              </template>
            </v-data-table>
            <div class="w-100 pb-10 mt-10">
     
              <a-pagination 
              
             
             
              v-model="page"
              :showTotal="(total) => `من أصل ${total} عنصر`"
              pageSize="10"

              :total="smsList.length"
              @showSizeChange="page"
              
              size="large" show-size-changer show-quick-jumper />
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" md="3">
          <router-view></router-view>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>
<style lang="scss" scoped>
.active {
  background: rgba(0, 0, 0, 0.125) !important;
}
</style>
<style lang="scss">
td {
  text-align: center;
}
</style>
<script>

import loading from "@/components/loading";
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2";
import aPagination from  'ant-design-vue/lib/pagination'

export default {
  components: {
    loading,
    aPagination,
  },
  props: {
    id: String,
  },
  data: () => ({
    page: 1,
    pageCount: 0,
    searchText: "",
    headers: [
      {
        text: "id",
        sortable: true,
        value: "id",
      },
      { text: "الرسالة", value: "message",sortable: false, },
      { text: "اسم المشترك", value: "shopName",sortable: true, },
      { text: "اسم الزبون ", value: "clientFullName",sortable: true, },
      { text: "رقم الهاتف المخصص", value: "phoneNumber",sortable: true, },
      { text: "مرسل من قبل", value: "userFullName",sortable: true, },
      { text: "تاريخ الإرسال", value: "sendDate",sortable: true, },
      
    ],
  }),
  methods: {
    ...mapActions(["setBreadcrumbs","fetchSMS"]),
    goToDetails(index) {
      if (index != this.id) {
        this.$router.push("./" + index);
      }
    },
 
  },
  computed: {
    ...mapGetters(["smsList", "isLoading"]),
  },
  created() {
    this.$store.dispatch("setBreadcrumbs", [
      {
        text: "سجل الرسائل SMS",
        disabled: false,
        href: "/smsrecords",
      },
    ]);
    this.fetchSMS();
     
  },
};
</script>
